import { whenReady } from '../javascript/utils'
import { loadGoogleMapsApi } from '../javascript/services/googleMaps.js'
 
loadGoogleMapsApi().then(maps => {
  const mapBlocks = document.querySelectorAll('.map-block')

  Array.from(mapBlocks).forEach(block => {
    const lat = parseFloat(block.dataset.lat)
    const lng = parseFloat(block.dataset.lng)
    const zoom = parseFloat(block.dataset.zoom)
    const label = block.dataset.label
    const infoContent = block.innerHTML
    const latLng = {lat, lng}

    const map = new maps.Map(block, {
      center: latLng,
      zoom: zoom,
      disableDefaultUI: true
    })

    const marker = new maps.Marker({
      map: map,
      position: latLng,
      title: label
    })

    const infowindow = new maps.InfoWindow({
      content: infoContent
    })

    marker.addListener('click', () => infowindow.open(map, marker))
  })
})